import dotProp from "dot-prop-immutable";
import {
  ACCEPT_GAUGE,
  REFRESH_GAUGE,
  REFRESH_REAL_METER,
  REMOVE_WALLPAPER,
  SELECT_WALLPAPER,
  START_GAUGING_UP,
  WALLPAPERS_ARE_LOADING,
  WALLPAPERS_FAILED,
  WALLPAPERS_LOADED
} from "../constants/wallpapersActions";
import {UPDATE_WALLPAPER} from "../constants/projectActions";

const initialState = {
  isLoading: false,
  errMessage: '',
  images: [],
  selectedIndex: false,
  isGaugingNow: false,
}

export default function(state = initialState, action) {
  switch (action.type) {
    case WALLPAPERS_ARE_LOADING:
      return dotProp.set(state, 'isLoading', true)
    case WALLPAPERS_FAILED:
      state = dotProp.set(state, 'isLoading', false)
      state = dotProp.set(state, 'errMessage', action.message)

      return state
    case WALLPAPERS_LOADED:
      state = dotProp.set(state, 'isLoading', false)
      state = dotProp.set(state, 'images', action.images)

      return state
    // case LOAD_PROJECT:
    //   return dotProp.set(state, 'selectedIndex', action.state.background.index)
    case SELECT_WALLPAPER:
      return dotProp.set(state, 'selectedIndex', action.index)
    case REMOVE_WALLPAPER:
      state = dotProp.set(state, 'selectedIndex', false)
      state = dotProp.delete(state, `images.${action.index}`)

      return state
    case START_GAUGING_UP:
      return dotProp.set(state, 'isGaugingNow', true)
    case REFRESH_GAUGE:
      return dotProp.set(state, `images.${action.index}.calibration.perMeter`, Math.abs(action.perMeter))
    case REFRESH_REAL_METER:
      return dotProp.set(state, `images.${action.index}.calibration.realMeter`, Math.abs(action.perMeter))
    case ACCEPT_GAUGE:
      return dotProp.set(state, 'isGaugingNow', false)
    case UPDATE_WALLPAPER:
      return dotProp.set(state, 'aspect', action.a)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/wallpapers.js